module.exports = __webpack_public_path__ + "img/banner5.d186eb56.jpg";